/**
 * base64url 转 Uint8Array（后端→前端）
 */
export function base64urlToUint8Array(base64url) {
    const base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
    const padLen = (4 - (base64.length % 4)) % 4;
    const padded = base64.padEnd(base64.length + padLen, '=');
    const bin = atob(padded);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) {
        arr[i] = bin.charCodeAt(i);
    }
    return arr;
}

/**
 * ArrayBuffer/Uint8Array 转 base64url（前端→后端）
 */
export function uint8ArrayToBase64url(buf) {
    const bin = String.fromCharCode(...new Uint8Array(buf));
    const base64 = btoa(bin);
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
